import { Grid } from '@material-ui/core';
import { AssuranceIcon } from 'images';
import React from 'react';
import { IconBlock } from 'containers/NavBarDashboard/styles';

export const MaintenanceScreen: React.FC = () => {
  return (
    <>
      <IconBlock
        isClickable={false}
        alt="logo-icon"
        data-testid="logo"
        src={AssuranceIcon['saham']}
      />
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="center"
        spacing={2}
        style={{
          backgroundColor: 'rgb(245, 247, 250)',
          height: '90vh',
          padding: '0 40px',
        }}
      >
        <Grid item xs={12} md={6} style={{ flex: 1 }} alignItems="flex-end">
          <div style={{ textAlign: 'left' }}>
            <h1
              style={{
                fontSize: '40px',
                fontFamily: 'Roboto',
                fontWeight: 'bold',
              }}
            >
              Maintenance en cours
            </h1>
            <p
              style={{
                color: 'rgba(75, 75, 75, 1)',
                margin: '16px 0',
                fontSize: '16px',
                fontFamily: 'Roboto',
                fontWeight: 'normal',
              }}
            >
              Afin de mieux vous servir, l'espace client est temporairement
              indisponible pour cause de maintenance. Nous mettons tout en œuvre
              pour rétablir l'accès dans les plus brefs délais.
            </p>
            <p
              style={{
                color: 'rgba(75, 75, 75, 1)',
                fontSize: '14px',
                fontFamily: 'Roboto',
                fontWeight: 'normal',
              }}
            >
              Merci pour votre compréhension.
            </p>
          </div>
        </Grid>

        <Grid item xs={12} md={4}>
          <img
            alt="Maintenance"
            src={AssuranceIcon.maintenance}
            style={{ maxWidth: '100%', height: 'auto' }}
          />
        </Grid>
      </Grid>
    </>
  );
};
